<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Accredited Body</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="seminarAccredit.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-textarea
              label="Description"
              :class="classPadding"
              v-model="seminarAccredit.desc"
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="License"
              v-model="seminarAccredit.licenseDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearLicense"
            >
              <template slot="append">
                <v-icon @click.stop="searchLicense">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <v-text-field
              label="CPE Credit"
              :class="classPadding"
              v-model="seminarAccredit.cpeCredit"
              v-mask="'##.##'"
              hint="hh.mm"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>

      <v-dialog v-model="editDialog" width="700" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editSeminarAccredit.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-textarea
                  label="Description"
                  :class="classPadding"
                  v-model="editSeminarAccredit.desc"
                  rows="1"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="License"
                  v-model="editSeminarAccredit.licenseDesc"
                  :class="classPadding"
                  clearable
                  readonly
                  @click:clear="clearLicense"
                >
                  <template slot="append">
                    <v-icon @click.stop="searchLicense">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="CPE Credit"
                  :class="classPadding"
                  v-model="editSeminarAccredit.cpeCredit"
                  v-mask="'##.##'"
                  hint="hh.mm"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Pa -->
      <v-dialog v-model="licenseDialog" width="900">
        <v-card>
          <v-card-title>
            <span class="headline">Licenses</span>
          </v-card-title>
          <v-card-text>
            <licenses :show-title="false" :show-dense="false">
              <template slot="actions" slot-scope="{ item }">
                <v-btn @click.stop="selectLicense(item)" text>Select</v-btn>
              </template>
            </licenses>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.prevent="licenseDialog = false" text
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Pagination from "./Pagination";
import Licenses from "../../others/licenses/Pagination";
import { mask } from "vue-the-mask";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
// import List from "./List";
const API_ENDPOINT = "/api/seminarAccredit";
export default {
  metaInfo: {
    title: "Accredited Body",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  directives: {
    mask
  },
  components: {
    // List
    Pagination,
    Licenses
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    seminarAccredit: {},
    componentKey: 0,
    editSeminarAccredit: {},
    editDialog: false,
    licenseDialog: false
  }),
  methods: {
    // ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, this.seminarAccredit)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editSeminarAccredit.code = rel.accreditCode;
      this.editSeminarAccredit.desc = rel.accreditDesc;
      this.editSeminarAccredit.licenseDesc = rel.licenseDesc;
      this.editSeminarAccredit.licenseCode = rel.licenseCode;
      this.editSeminarAccredit.cpeCredit = rel.cpeCredit;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.accreditCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.seminarAccredit = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.editSeminarAccredit)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchLicense() {
      this.licenseDialog = true;
    },
    selectLicense(item) {
      if (!this.editDialog) {
        this.seminarAccredit.licenseDesc = item.licenseDesc;
        this.seminarAccredit.licenseCode = item.licenseCode;
      } else {
        this.editSeminarAccredit.licenseDesc = item.licenseDesc;
        this.editSeminarAccredit.licenseCode = item.licenseCode;
      }
      this.licenseDialog = false;
    },
    clearLicense() {
      if (!this.editDialog) {
        this.seminarAccredit.licenseDesc = null;
        this.seminarAccredit.licenseCode = null;
      } else {
        this.editSeminarAccredit.licenseDesc = null;
        this.editSeminarAccredit.licenseCode = null;
      }
    }
  },
  created() {
    this.getUserAccessRights("SeminarAcc");
  }
};
</script>